module.exports = __webpack_public_path__ + "f0b8dda22d35f78ec68486338d7aeae2.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/RobotoCondensed-Regular.ttf
 ** module id = 910
 ** module chunks = 9
 **/